(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/views/prolongation-page.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/views/prolongation-page.js');

'use strict';

svs.keno.views.ProlongationPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'keno',
    component: 'prolongation'
  }],
  regions: {
    prolongationRegion: '#ngProlongationRegion'
  },
  template() {
    return svs.keno.templates.prolongation_page();
  },
  onRender() {
    if (svs.keno.components.prolongation) {
      this.showChildView('prolongationRegion', new svs.keno.components.prolongation.views.Prolongation());
    }
  }
});

 })(window);